"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaRebalanced = void 0;
var Colony_1 = require("./Colony");
var ColonyName_1 = require("./ColonyName");
var ColonyBenefit_1 = require("./ColonyBenefit");
var Resources_1 = require("../Resources");
var LunaRebalanced = (function (_super) {
    __extends(LunaRebalanced, _super);
    function LunaRebalanced() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ColonyName_1.ColonyName.LUNA_REBALANCED;
        _this.description = 'MegaCredits';
        _this.buildType = ColonyBenefit_1.ColonyBenefit.GAIN_PRODUCTION;
        _this.buildQuantity = [2, 2, 2];
        _this.buildResource = Resources_1.Resources.MEGACREDITS;
        _this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.tradeQuantity = [1, 2, 4, 7, 10, 13, 17];
        _this.tradeResource = Resources_1.Resources.MEGACREDITS;
        _this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.colonyBonusQuantity = 2;
        _this.colonyBonusResource = Resources_1.Resources.MEGACREDITS;
        return _this;
    }
    return LunaRebalanced;
}(Colony_1.Colony));
exports.LunaRebalanced = LunaRebalanced;
//# sourceMappingURL=LunaRebalanced.js.map